var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaterPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.58496C8.39303 2.58496 6.82214 3.06148 5.486 3.95427C4.14985 4.84706 3.10844 6.11601 2.49348 7.60066C1.87852 9.08531 1.71762 10.719 2.03112 12.2951C2.34463 13.8712 3.11846 15.3189 4.25476 16.4552C5.39106 17.5915 6.8388 18.3653 8.4149 18.6788C9.99099 18.9923 11.6247 18.8314 13.1093 18.2165C14.594 17.6015 15.8629 16.5601 16.7557 15.224C17.6485 13.8878 18.125 12.3169 18.125 10.71C18.1209 8.55635 17.2635 6.49212 15.7407 4.96928C14.2178 3.44644 12.1536 2.58909 10 2.58496ZM14.375 11.335H10C9.83424 11.335 9.67527 11.2691 9.55806 11.1519C9.44085 11.0347 9.375 10.8757 9.375 10.71V6.33496C9.375 6.1692 9.44085 6.01023 9.55806 5.89302C9.67527 5.77581 9.83424 5.70996 10 5.70996C10.1658 5.70996 10.3247 5.77581 10.4419 5.89302C10.5592 6.01023 10.625 6.1692 10.625 6.33496V10.085H14.375C14.5408 10.085 14.6997 10.1508 14.8169 10.268C14.9342 10.3852 15 10.5442 15 10.71C15 10.8757 14.9342 11.0347 14.8169 11.1519C14.6997 11.2691 14.5408 11.335 14.375 11.335Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaterPurple);
export default __webpack_public_path__ + "static/media/laterPurple.f6a97afd16bc54216bbfbf1ed9d08817.svg";
export { ForwardRef as ReactComponent };